import { useState, useEffect, useContext } from 'react';

import { PracticeReseveContext } from '../../../../../../PracticeReseveContext';


// シチュエーションごと:ビジネス
function PracticeReserveSituationCaseCategoryBusiness(props: any) {

  const { title } = useContext(PracticeReseveContext);

  return (
    <li className="list-group-item text-center">
      <p>
        ビジネスコースの{title}は
        <br className="visible-xs" />
        ご購入後にご利用可能です
      </p>
      <a
        href="/settlement/extension?target=business#business"
        className="btn btn-primary"
      >
        ビジネスコースのご購入はコチラ
      </a>
    </li>
  );
}
  
export default PracticeReserveSituationCaseCategoryBusiness;